// extracted by mini-css-extract-plugin
export default {"resourceCenterIcon":"M4cTy31QRDTPKuzo8DDv"};